<div [ngClass]="{'map-overlay': true, 'loading': (apiLoaded | async) === false}">
  <div #map1 id="map1" class="map-container">
    <google-map
      #googleMapRef
      id="googleMapRef"
      *ngIf="apiLoaded | async"
      class="google-map"
      height="100%"
      width="100%"
      [center]="(searchUI$ | async)?.mapCenter!"
      [zoom]="(searchUI$ | async)?.mapZoom!"
      [options]="mapOptions"
      (mapDragend)="onMapDrag()"
      (zoomChanged)="onMapZoomChanged()"
    >
      <map-marker-clusterer
        (clusterClick)="onMarkerClusterWindow($event,this)"
        [zoomOnClick]="false"
        [imagePath]="markerClustererImagePath"
      >
        <map-marker
          #markerElement="mapMarker"
          *ngFor="let marker of markers; let i = index"
          [position]="marker.getPosition()!"
          [title]="marker.getTitle()!"
          [draggable]="false"
          [icon]="marker.getIcon()!"
          (mapClick)="onMarkerClick(i,marker,marker.getTitle()!)"
          (mapMouseover)="setMarkerBig($event)"
          (mapMouseout)="setMarkerNormal($event)"
          (mapMouseup)="setMarkerBig($event)"
          (mapMousedown)="setMarkerSmall($event)"
        >
        </map-marker>
      </map-marker-clusterer>
    </google-map>
    <fal-loading-spinner style="width: 100%; height: 100%" [isLoading]="(apiLoaded | async) === false"> </fal-loading-spinner>
  </div>
</div>
<div class="cluster-dialog" [style.visibility]="showDialog ? 'visible' : 'hidden'" #clusterDiv>
  <div class="markersContainer">
    <div *ngIf="clusterDialog">
      <div *ngFor="let marker of markersLocation;">
        <div class="markerslist" style="cursor: pointer" id="{{marker.getTitle()}}">
          <div class="circle">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 448 512">
                <path d="M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"/>
              </svg>
            </span>
          </div>
          <div class="markerTitle">
            <p tabindex="0">{{getTitle(marker)}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="mapPinDialog">
    <div *ngIf="location">
      <h3 class="h3-margin" *ngIf="innerWidth > mobileMax">
        <a tabindex="0" fal-location-detail-link>{{location.name}} - {{location.address.city}}, {{ location.address.state }}</a>
      </h3>
      <h4 *ngIf="innerWidth <= mobileMax" [ngClass]="{'h4-text-align' : innerWidth <= mobileMax}">
        <a tabindex="0" fal-location-detail-link>{{location.name}} - {{location.address.city}}, {{ location.address.state }}</a>
      </h4>
      <br *ngIf="location.locationHours[0].is24Hours" />
      <div class="office-hour" *ngIf="location.locationHours[0].is24Hours">
        <div class="icon" style="top: 3px; left: 2px">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
              fill="var(--dhcl-color-primary)"
            />
            <rect x="7.33398" y="3.33331" width="1.33333" height="6" rx="0.666667" fill="var(--dhcl-color-primary)" />
            <rect
              x="11.334"
              y="8"
              width="1.33333"
              height="4"
              rx="0.666667"
              transform="rotate(90 11.334 8)"
              fill="var(--dhcl-color-primary)"
            />
          </svg>
        </div>
        <div class="text">
          <span [ngClass]="{'span-font' : innerWidth <= mobileMax}">{{is24OpenTitle}}</span>
        </div>
      </div>
      <br />
      <div class="line-item">
        <div class="icon" style="top: 3px; left: 2px">
          <fal-icons-pin></fal-icons-pin>
        </div>
        <div tabindex="0" class="text address-details">
          <span [ngClass]="{'span-font' : innerWidth <= mobileMax}">{{ location.address.addressLine1 }}</span><br />
          <span *ngIf="location.address.addressLine2" [ngClass]="{'span-font' : innerWidth <= mobileMax}"
            >{{ location.address.addressLine2 }}</span
          ><br *ngIf="location.address.addressLine2" />
          <span [ngClass]="{'span-font' : innerWidth <= mobileMax}">{{ location.address.city}}, {{ location.address.state }}</span>
          <span [ngClass]="{'span-font' : innerWidth <= mobileMax}"> {{ location.address.zipCode }} </span>
        </div>
        <br />
        <div *ngIf="!!location.phoneNumber" class="line-item">
          <div class="icon" style="top: 3px; left: 2px">
            <fal-icons-phone></fal-icons-phone>
          </div>
          <div class="text">
            <a class="phone" [ngClass]="{'span-font' : innerWidth <= mobileMax}" href="tel:{{ location.phoneNumber }}"
              >{{ location.phoneNumber }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
